/**
 * @file ContactUs.js
 * @module src/js/components/ContactUs
 * @description
 * **Contact component providing contact information and location map on the home page.**
 * - Displays office address, phone, fax, and email details.
 * - Includes an embedded Google Map for location reference.
 *
 * @version
 * <p>
 *  2025-11-29: First version with documentation. (Zong-Han Wu, zhwu@eda.ee.ntu.edu.tw)<br/>
 *  2025-12-02: Rename from Contact to ContactUs to avoid naming conflict. (Zong-Han Wu, zhwu@eda.ee.ntu.edu.tw)<br/>
 * </p>
 */
import ThemeToggledWrapper from "./ThemeToggledWrapper";
import { MailTo, Tel } from "./UtilityComponents";

export default function ContactUs() {
    return (
        <ThemeToggledWrapper id="contact-us" lightStyle={5} darkStyle={4}>
            <div className="inner">
                <header className="major special">
                    <h2>Contact Us</h2>
                </header>
                <div className="row" style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                    <div className="table-wrapper">
                        <table style={{textAlign: 'left'}}>
                            <tbody>
                                <tr>
                                    <td><i className="fa-solid fa-building" style={{marginRight: '0.3em'}}></i>Office</td>
                                    <td>博理館 (Barry Lam Hall) BL406</td>
                                </tr>
                                <tr>
                                    <td><i className="fa-solid fa-location-dot" style={{marginRight: '0.3em'}}></i>Address</td>
                                    <td>106319台北市大安區羅斯福路四段一號<br />(No. 1, Sec. 4, Roosevelt Rd., Taipei 106319)</td>
                                </tr>
                                <tr>
                                    <td><i className="fa-solid fa-phone" style={{marginRight: '0.3em'}}></i>Phone</td>
                                    <td>
                                        <Tel tel="+886-2-3366-3366" /> - 55409
                                        {/* <Tel tel="+886-2-3366-3700" /> - 6406<br />
                                        <Tel tel="+886-2-2363-5251" /> - 6406 */}
                                    </td>
                                </tr>
                                <tr>
                                    <td><i className="fa-solid fa-fax" style={{marginRight: '0.3em'}}></i>Fax</td>
                                    <td>
                                        <Tel tel="+886-2-2368-1679" /><br />
                                        請註明 博理館406室 EDA實驗室 (Please note EDA Lab, BL406)
                                    </td>
                                </tr>
                                <tr>
                                    <td><i className="fa-solid fa-envelope" style={{marginRight: '0.3em'}}></i>Email</td>
                                    <td>Prof. Chang: <MailTo mail="ywchang@ntu.edu.tw" /></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3615.435558100784!2d121.53972127508553!3d25.019288638884316!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3442aa267158ff23%3A0x280b7e1a98cc05ca!2sBarry%20Lam%20Hall!5e0!3m2!1sen!2stw!4v1740442497902!5m2!1sen!2stw"
                    title="barry-lam-hall"
                    width="100%" height="400"
                    style={{border: 0, margin: 'auto', display: 'flex', justifyContent: 'center', alignItems: 'center'}}
                    allowFullScreen
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade">
                </iframe>
            </div>
        </ThemeToggledWrapper>
    );
}
